import React from 'react';

export function LosAngelesAddress() {
	return (
		<tr style={{ verticalAlign: 'middle' }}>
			<td
				style={{
					padding: '5px 0 0',
					fontSize: '11px',
					color: '#808080',
					lineHeight: '14px',
					textDecoration: 'none'
				}}
			>
				<a
					href="https://goo.gl/maps/rv7LkPoEKydiyFvf6"
					target="_blank"
					rel="noopener noreferrer"
					color="#808080"
					style={{ textDecoration: 'none', color: '#808080' }}
				>
					<span>200 N. Pacific Coast Hwy, Suite 110</span>
					<br />
					El Segundo, California, 90245
				</a>
			</td>
		</tr>
	);
}
